export default "__VITE_ASSET__ItYBwxuD__"